import { v4 as uuidv4 } from 'uuid';

import dateService from '@gem/services/date-service';

import Tasks from 'APP/Tasks';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export async function createDraftArticle(groupId: string, payload: ArticlePayload): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  const canSend = Tasks.messaging.canSendMessage({ groupId, isCheckSlowMode: false, payload });
  if (!canSend.result) {
    canSend.error && Tasks.app.showToast(canSend.error);
    return;
  }

  try {
    const draftData = await messageModel.saveDraft({
      groupId,
      clientTime: dateService.now().getTime().toString(),
      clientUuid: uuidv4(),
      payload: payload.toJSON(),
    });

    const draftMessage = new ChatMessage(draftData, group.messagesStore);
    group.draftsStore.setDraft(draftMessage);
  } catch {
    //
  }
}
